import React from 'react';

type ThumbsDownIconProps = { width?: string; height?: string; color?: string };

function ThumbsDownIcon({
  width = '23',
  height = '22',
  color = 'black',
}: ThumbsDownIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 22 22'
      fill='none'
    >
      <path
        d='M15.6827 1V12M20.6827 8.8V4.2C20.6827 3.07989 20.6827 2.51984 20.4647 2.09202C20.2729 1.71569 19.967 1.40973 19.5907 1.21799C19.1628 1 18.6028 1 17.4827 1H6.80068C5.3392 1 4.60846 1 4.01825 1.26743C3.49807 1.50314 3.05597 1.88242 2.74391 2.36072C2.38984 2.90339 2.27873 3.62564 2.0565 5.07012L1.53342 8.47012C1.24031 10.3753 1.09376 11.3279 1.37647 12.0691C1.62461 12.7197 2.09132 13.2637 2.69659 13.6079C3.3862 14 4.35 14 6.2776 14H7.08267C7.64272 14 7.92275 14 8.13666 14.109C8.32482 14.2049 8.4778 14.3578 8.57368 14.546C8.68267 14.7599 8.68267 15.0399 8.68267 15.6V18.5342C8.68267 19.896 9.78666 21 11.1485 21C11.4733 21 11.7677 20.8087 11.8996 20.5119L15.2604 12.9502C15.4132 12.6062 15.4897 12.4343 15.6105 12.3082C15.7173 12.1967 15.8484 12.1115 15.9936 12.0592C16.1579 12 16.3461 12 16.7225 12H17.4827C18.6028 12 19.1628 12 19.5907 11.782C19.967 11.5903 20.2729 11.2843 20.4647 10.908C20.6827 10.4802 20.6827 9.9201 20.6827 8.8Z'
        stroke={color}
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default ThumbsDownIcon;
